import downloadFile from '@/storybook/utils/downloadFile';

const NEEDS_QUOTING = /[",\n\r]/;

function escapeCsvValue(value: string): string {
  if (NEEDS_QUOTING.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }

  return value;
}

function extractCells(row: HTMLTableRowElement): ReadonlyArray<string> {
  return Array.from(row.cells).map(cell => escapeCsvValue(cell.textContent?.trim() ?? ''));
}

export function generateCsvFromTable(table: HTMLTableElement): string {
  const rows: string[] = [];

  const thead = table.tHead;
  if (thead) {
    Array.from(thead.rows).forEach(headerRow => {
      rows.push(extractCells(headerRow).join(','));
    });
  }

  Array.from(table.tBodies).forEach(tbody => {
    Array.from(tbody.rows).forEach(bodyRow => {
      rows.push(extractCells(bodyRow).join(','));
    });
  });

  const tfoot = table.tFoot;
  if (tfoot) {
    Array.from(tfoot.rows).forEach(footerRow => {
      rows.push(extractCells(footerRow).join(','));
    });
  }

  return rows.join('\n');
}

export function downloadCsv(csvContent: string, fileName: string = `agent-table-${Date.now()}.csv`): void {
  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  try {
    downloadFile(url, fileName);
  } finally {
    URL.revokeObjectURL(url);
  }
}
